export const mapLabelsToValues = (labelString, options) => {
  if (!labelString) return [];
  const labels = labelString
    ?.split(",")
    ?.map((l) => l.trim())
    ?.filter(Boolean);

  const values = options
    .filter((opt) => labels.includes(opt.label))
    .map((opt) => opt.value);

  // ✅ single value → return value
  if (values.length === 1) {
    return values[0];
  }

  // ✅ multiple values → return array
  return values;
};

export const mapValuesToLabels = (valueInput, options) => {
  if (valueInput === null || valueInput === undefined) return "";

  // Normalize to array
  const values = Array.isArray(valueInput) ? valueInput : [valueInput];

  const labels = options
    .filter((opt) => values.includes(opt.value))
    .map((opt) => opt.label);

  // ✅ single value → return string
  if (labels.length === 1) {
    return labels[0];
  }

  // ✅ multiple values → return comma-separated string
  return labels.join(", ");
};
